import { defaultTo } from 'lodash';
import { DateTime } from 'luxon';
import { IModel, Model } from './Model';

export interface IConsentModel extends IModel {
  consentId: number;
  consentTypeId: number;
  stateId: number | undefined;
  storeId: number | undefined;
  startDate: string;
  endDate: string | undefined;
  legalBackerHTML: string;
  consentTypePublicId: string;
  consentTypeAuthApplicationKey: string;
  consentTypeAuthApplicationDescription: string;
  consentTypeName: string;
  stateName: string | undefined;
  stateAbbreviation: string | undefined;
  storeCode: string | undefined;
  storeName: string | undefined;
}

export class ConsentModel
  extends Model
  implements Record<keyof IConsentModel, any>
{
  consentId: number;
  consentTypeId: number;
  stateId: number | undefined;
  storeId: number | undefined;
  startDate: DateTime;
  endDate: DateTime | undefined;
  legalBackerHTML: string;
  consentTypePublicId: string;
  consentTypeAuthApplicationKey: string;
  consentTypeAuthApplicationDescription: string;
  consentTypeName: string;
  stateName: string | undefined;
  stateAbbreviation: string | undefined;
  storeCode: string | undefined;
  storeName: string | undefined;

  constructor(params: Partial<IConsentModel>) {
    super(params);
    this.consentId = defaultTo(params.consentId, 0);
    this.consentTypeId = defaultTo(params.consentTypeId, 0);
    this.stateId = params.stateId;
    this.storeId = params.storeId;
    this.startDate = DateTime.fromISO(
      defaultTo(params.startDate, '2000-01-01'),
      { zone: 'utc' },
    );
    this.endDate = params.endDate
      ? DateTime.fromISO(params.endDate, { zone: 'utc' })
      : undefined;
    this.legalBackerHTML = defaultTo(params.legalBackerHTML, '');
    this.consentTypePublicId = defaultTo(params.consentTypePublicId, '');
    this.consentTypeAuthApplicationKey = defaultTo(
      params.consentTypeAuthApplicationKey,
      '',
    );
    this.consentTypeAuthApplicationDescription = defaultTo(
      params.consentTypeAuthApplicationDescription,
      '',
    );
    this.consentTypeName = defaultTo(params.consentTypeName, '');
    this.stateName = params.stateName;
    this.stateAbbreviation = params.stateAbbreviation;
    this.storeCode = params.storeCode;
    this.storeName = params.storeName;
  }
}
